// Whitelist HTML sanitizer for admin-authored rich text (the News section).
// DOM-based (via DOMParser) rather than regex, so it reliably strips scripts,
// event handlers, javascript:/data: URLs, and unknown tags while keeping the
// formatting the editor produces (headings, bold/italic, lists, links, images,
// colored spans).

const ALLOWED_TAGS = new Set([
  'H1', 'H2', 'H3', 'H4', 'P', 'DIV', 'SPAN', 'B', 'STRONG', 'I', 'EM', 'U',
  'S', 'UL', 'OL', 'LI', 'A', 'IMG', 'BR', 'BLOCKQUOTE',
])

// Tags whose content is dropped entirely (not just unwrapped).
const DROP_TAGS = new Set([
  'SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'EMBED', 'LINK', 'META', 'FORM',
  'INPUT', 'BUTTON', 'TEXTAREA', 'SELECT',
])

const ATTR_BY_TAG = {
  A: ['href', 'target', 'rel', 'title'],
  IMG: ['src', 'alt', 'width', 'height'],
}
const GLOBAL_ATTR = ['style']

const isBadUrl = v => {
  const s = (v || '').trim().toLowerCase()
  if (s.startsWith('javascript:') || s.startsWith('vbscript:')) return true
  if (s.startsWith('data:') && !s.startsWith('data:image/')) return true
  return false
}

const cleanNode = node => {
  Array.from(node.childNodes).forEach(child => {
    if (child.nodeType === 1) {
      const tag = child.tagName

      if (DROP_TAGS.has(tag)) {
        child.remove()
        return
      }

      if (!ALLOWED_TAGS.has(tag)) {
        // Unwrap: clean its descendants, then splice them in where it sat.
        cleanNode(child)
        while (child.firstChild) node.insertBefore(child.firstChild, child)
        node.removeChild(child)
        return
      }

      const allowed = (ATTR_BY_TAG[tag] || []).concat(GLOBAL_ATTR)
      Array.from(child.attributes).forEach(a => {
        const name = a.name.toLowerCase()
        if (name.startsWith('on') || !allowed.includes(name)) {
          child.removeAttribute(a.name)
        } else if ((name === 'href' || name === 'src') && isBadUrl(a.value)) {
          child.removeAttribute(a.name)
        } else if (name === 'style' && /expression|javascript:|url\s*\(/i.test(a.value)) {
          child.removeAttribute(a.name)
        }
      })

      if (tag === 'A' && child.getAttribute('target') === '_blank') {
        child.setAttribute('rel', 'noopener noreferrer')
      }

      cleanNode(child)
    } else if (child.nodeType === 8) {
      child.remove() // comments
    }
  })
}

export const sanitizeHtml = html => {
  const doc = new DOMParser().parseFromString(html || '', 'text/html')
  cleanNode(doc.body)
  return doc.body.innerHTML
}
